<template>
    <div class="com-nav block">
        <div class="com-nav-wrapper container">
            <div class="com-nav__logo">
                <a href="/"><img src="@/assets/logo.png"/></a>
            </div>
            <div :class="['com-nav__menu-icon', {'is-collpase': collpased}]" @click="collpase"></div>
            <div :class="['com-nav__menu', {'is-collpase': collpased}]">
                <div class="com-nav__menu-items">
                    <a class="com-nav__menu-item" @click="scollTop('advantage')">系统优势</a>
                    <a class="com-nav__menu-item" @click="scollTop('process')">合作流程</a>
                    <a class="com-nav__menu-item" @click="scollTop('contact')">联系我们</a>
                    <!-- <a class="com-nav__menu-item" href="/merchant/apply?s=0">申请合作</a> -->
                    <div class="com-nav__consumer">
                        <a href="tel:01213188285">01213188285</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'site-nav',
    data() {
        return {
            collpased: false,
        }
    },
    methods: {
        collpase() {
            this.collpased = !this.collpased;
        },
        scollTop(name) {
            this.collpased = !this.collpased;
            this.$emit('scroll', name)
        }
    }
}
</script>

<style lang="less" scoped>
    .com-nav {
        padding: .25rem 0;
        background: -webkit-linear-gradient(left,#40bc66,#7cc54f);
        position: fixed;
        z-index: 10;
        top: 0;
        &-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
        }
        &__logo {
            img {
                width: 1.5rem;
                margin-top: .05rem;
            }
        }
        &__menu {
            &-items {
                display: flex;
                align-items: center;
            }
            &-item {
                margin-left: .3rem;
                font-size: .28rem;
                cursor: pointer;
                color: #fff;
            }
            &-icon {
                display: none;
                width: .6rem;
                height: .6rem;
                background: url('~@/assets/a.svg');
                background-size: cover;
                &.is-collpase {
                    background-image: url('~@/assets/b.svg');
                }
            }
        }
        &__consumer {
            a {
                color: #fff;
                font-size: .4rem;
                background: url('~@/assets/po.svg') no-repeat left center;
                background-size: .4rem;
                padding-left: .5rem;
                margin-left: .35rem;
                text-decoration: none;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    @media only screen and (max-width: 750px) {
        .com-nav {
            background: #40bc66;
            &-wrapper {
                padding: 0 .5rem;
                box-sizing: border-box;
            }
            &__menu {
                display: none;
                width: 100%;
                &-items {
                    display: block;
                    margin-top: 0.3rem;
                }
                &-item {
                    display: block;
                    width: 100%;
                    margin: 0;
                    text-align: center;
                    line-height: 1rem;
                    font-size: .38rem;
                    border-top: 1px solid #57c779;
                }
                &-icon {
                    display: inline-block;
                }
                &.is-collpase {
                    display: block;
                }
            }
            &__consumer {
                display: none;
            }
        }
    }
</style>

